import { FunctionComponent, memo, useRef } from "react";
import classNames from "classnames";
import { Tooltip } from "@edgetier/components";
import { useIsOverflowed } from "@edgetier/utilities";

import InfoTooltip from "../info-tooltip";
import { IProps } from "./labeled-field.types";
import "./labeled-field.scss";
import { faQuestionCircle } from "@fortawesome/pro-solid-svg-icons";

/**
 * Wrap any field and display a label
 * @param props.name        Field name
 * @param props.label       Label displayed
 * @param props.children    Field component(s)
 * @param props.infoTooltip Optional tooltip content
 */
const LabeledField: FunctionComponent<IProps> = ({ label, children, name, infoTooltip }) => {
    const labelRef = useRef(null);
    const isOverflowed = useIsOverflowed(labelRef, "width");

    return (
        <div className={classNames("field", "labeled-field")}>
            <Tooltip useArrow content={label} disableTooltip={!isOverflowed} placement="top-center">
                <label ref={labelRef} htmlFor={name} className="labeled-field__label" id={`${name}-label`}>
                    {label}
                    {infoTooltip && (
                        <span className="labeled-field__info-tooltip">
                            <InfoTooltip placement="top-center" icon={faQuestionCircle} content={infoTooltip} />
                        </span>
                    )}
                </label>
            </Tooltip>
            {children}
        </div>
    );
};

export default memo(LabeledField);
